<template>
  <div class="news-content-container">
    <div class="back-center-panel">
      <div class="back-center" @click="handleJumpPage('OPEN_NEWSCENTER')">
        <div class="back-icon">
          <div class="back-link">返回新闻中心</div>
        </div>
      </div>
    </div>
    <div class="news-content-panel">
      <div class="news-title">报名开启 | “智变未来”腾讯产业数字化转型论坛，邀你共同参与</div>
      <div class="news-date">2022年3月3日</div>
      <div class="news-content">
        <p>在经济全球化和新技术快速发展的背景下，全球产业链发生巨变。数字科技正成为企业增长的新引擎，被加速应用于各行各业。在刚刚过去的2021年，中国凭借供应链强大的“韧性”和数字化技术的应用，实现了后疫情时代下的经济正增长。可以预见，实体经济与数字经济加速融合，不仅是新的经济增长点，也是当前产业数字化转型的支点。</p>
        <p>过去20年来，腾讯扎根于消费互联网，积累了非常多的能力和技术优势，在产业互联网的大潮中，腾讯也一直在思考<strong>如何助力实体经济转型升级。</strong></p>
        <p>数字经济浪潮奔涌的时代背景下，企业如何走好数字化转型之路？</p>
        <p><strong>3月18日</strong>，由<strong>上海经济和信息化委</strong>指导，<strong>腾讯华东总部和腾讯优图实验室</strong>联合主办，<strong>腾讯企点、腾讯WeTest、腾讯云AI、腾讯研究院、上海智慧城市发展研究院</strong>联合支持的2022年首场<strong>“智变未来”腾讯产业数字化转型论坛</strong>即将在<strong>上海市西岸美术馆报告厅举办</strong>，在此，我们邀请学界、业界的各位大咖，与您一同参与这场产业智变的深度讨论，诚意邀您<strong>一同参加</strong>。</p>
        <div class="news-middle-title">嘉宾阵容</div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_1.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_2.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_3.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_4.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_5.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_6.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_7.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_8.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_9.png" />
        </div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_10.png" />
        </div>
        <div class="news-middle-info info-link">扫描下方二维码或点击“<a href="https://doc.weixin.qq.com/forms/AJEAIQdfAAoAYMAQgY1ABQ8S1M1qBSRsf#/fill" target="_blank">阅读原文</a>”即刻报名参加</div>
        <div class="news-middle-info">“智变未来”，一起探索企业数字化转型新思路！</div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news8_11.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';
export default {
  name: 'news8',
  methods: {
    handleJumpPage(url, key) {
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, { key: key });
        return;
      }
      this.$router.transfer(url);
    }
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content-container {
  .news-content-panel .news-content{
    .news-middle-title {
      color: #3D485D;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      margin: 20px 0;
    }
    .news-middle-info {
      color: #3D485D;
      font-size: 14px;
      text-align: center;
      margin: 20px 0;
    }
    .info-link {
      color: #0080FF;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News8.vue